export default __webpack_public_path__ + "static/media/20210819182523.e7fe5a32.png";